export default "__VITE_ASSET__72da75c0__"